import SiteLayout from "@/components/feature/SiteLayout";
import useSeo from "@/hooks/useSeo";
import { dramas, faqs, siteInfo } from "@/mocks/dramas";
import Hero from "@/pages/home/components/Hero";
import TopThree from "@/pages/home/components/TopThree";
import GenreGrid from "@/pages/home/components/GenreGrid";
import DramaSection from "@/pages/home/components/DramaSection";
import Testimonials from "@/pages/home/components/Testimonials";
import FaqSection from "@/pages/home/components/FaqSection";
import SubscribeSection from "@/pages/home/components/SubscribeSection";

const topThree = [...dramas].sort((a, b) => b.rating - a.rating).slice(0, 3);
const hotPicks = [...dramas].sort((a, b) => b.heat - a.heat).slice(0, 8);
const newArrivals = [...dramas]
  .filter((d) => d.year >= 2026 || d.status === "更新中")
  .sort((a, b) => b.year - a.year)
  .slice(0, 4);

const HOME_JSON_LD = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: siteInfo.name,
    alternateName: "黑料短剧排行榜",
    description: siteInfo.description,
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: "https://heiliao-theater.cn/ranking?q={search_term_string}",
      },
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: siteInfo.name,
    description: "专注于短剧排行榜、同款类似剧与新剧速递的内容平台。",
    email: siteInfo.email,
    slogan: siteInfo.slogan,
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "黑料短剧口碑榜 TOP 3",
    itemListElement: topThree.map((drama, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: drama.title,
      url: `https://heiliao-theater.cn/drama/${drama.id}`,
    })),
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  },
];

export default function Home() {
  useSeo({
    title: "黑料短剧 - 黑料短剧排行榜与热门短剧推荐",
    description:
      "黑料短剧排行榜与同款类似新剧一站找齐：汇总热门短剧、新剧推荐与口味分类，按豪门恩怨、重生逆袭、悬疑复仇等口味挑片不踩雷，同类好剧持续更新。",
    keywords: "黑料短剧,黑料短剧推荐,黑料短剧类似,黑料短剧同款,黑料短剧排行榜,黑料短剧热门短剧,黑料短剧新剧",
    path: "/",
    jsonLd: HOME_JSON_LD,
  });

  return (
    <SiteLayout>
      <Hero />
      <TopThree items={topThree} />
      <GenreGrid />
      <DramaSection
        id="hot"
        eyebrow="热门推荐"
        title="正在被最多人追的黑料短剧"
        desc="按站内热度排序，反映近期真实追剧趋势。热度高的作品往往节奏更快、反转更密，适合想立刻上头的你。"
        items={hotPicks}
        ctaTo="/ranking?tab=hot"
        ctaLabel="查看热度榜"
        tone="tint"
      />
      <DramaSection
        id="new"
        eyebrow="新剧速递"
        title="刚上线、值得先收藏的新剧"
        desc="新剧上线 24 小时内补录。这里挑出近期口碑起势明显的新作，先收藏再慢慢追。"
        items={newArrivals}
        ctaTo="/ranking?tab=new"
        ctaLabel="查看新剧榜"
        columnCount={4}
      />
      <Testimonials />
      <FaqSection />
      <SubscribeSection />
    </SiteLayout>
  );
}